function createPointsListTemplate() {
  return '<ul class="trip-events__list"></ul>';
}

export {createPointsListTemplate};
